export default __webpack_public_path__ + "static/media/3.06572c9c.jpg";